(function () {
  /* Scroll the 2-up carousel back to position 0 after a variant change
     so the selected variant's image is always visible first. */
  document.addEventListener('variant:update', function () {
    /* replaceWith() already creates a fresh element at scroll=0,
       but we cover the edge-case where it doesn't fire. */
    var gList = document.querySelector('.g2up-list');
    if (gList) {
      gList.scrollTo({ left: 0, behavior: 'instant' });
    }
  });
})();
